const imports = require("../../../lib");
module.exports = imports.google.type;

const grpc = {};
grpc.web = require("grpc-web");
